export enum UserRoles {
  ADMIN = 'admin',
  USER = 'authenticated',
  SECURITY = 'security',
}
